import { LinkPageProps } from "../components/LinkPage";

export function linkPageClassName(tag: LinkPageProps["tag"]) {
  switch (tag) {
    case "mkhc-active-tab":
      return "mkhc-active-tab mkhc-tab";
    case "mkhc-tab":
      return "mkhc-tab";
    case "mkhc-black-link":
      return "hover:tw-underline tw-cursor-pointer tw-font-bold tw-underline";
    case undefined:
      return "tw-text-secondary hover:tw-underline tw-cursor-pointer tw-font-bold";
  }
}
